<onsip-header-main>
  <onsip-header-page-title
    ><span
      [innerHtml]="
        'ONSIP_I18N.CUSTOMIZE_YOUR_STRONGSAYSOSTRONG_SETTINGS' | translate | sentenceCase
      "
    ></span
  ></onsip-header-page-title>
</onsip-header-main>
<onsip-fixed-width-card-list width="456px">
  <mat-card onsip-section-card>
    <mat-card-header>
      <mat-card-title>{{ "ONSIP_I18N.TOPICS" | translate }}</mat-card-title>
      <onsip-spacer></onsip-spacer>
      <a class="primary-500" [routerLink]="views.SAYSO_ADD">{{ "ONSIP_I18N.ADD" | translate }}</a>
    </mat-card-header>
    <mat-card-content>
      <onsip-topic-list></onsip-topic-list>
    </mat-card-content>
  </mat-card>
  <mat-card onsip-section-card>
    <mat-card-title>{{ "ONSIP_I18N.DISPLAY_SETTINGS" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-sayso-color-picker
        (accentColorChange)="successSnackbar()"
        (buttonColorChange)="successSnackbar()"
        (buttonPositionChange)="successSnackbar()"
        (gradientOverlayChange)="successSnackbar()"
      >
      </onsip-sayso-color-picker>
    </mat-card-content>
  </mat-card>
  <mat-card onsip-section-card>
    <mat-card-title>{{ "ONSIP_I18N.SETTINGS_AND_INSTALLATION" | translate }}</mat-card-title>
    <mat-card-content>
      <div class="onsip-sayso-settings-grid">
        <span class="onsip-sayso-settings-toggles">
          <div class="mat-button-2">{{ "ONSIP_I18N.ENABLE_SAYSO" | translate }}</div>
          @if (allTopicsDisabled) {
          <mat-slide-toggle
            class="topic-mat-slide-toggle"
            color="primary"
            [disabled]="(hasTopics | async) === false"
            [checked]="(allTopicsDisabled | async) === false"
            (change)="setAllDisabled(!$event.checked)"
            disableRipple
          >
          </mat-slide-toggle>
          }
        </span>
        <h5>
          {{
            "ONSIP_I18N.TOGGLING_THIS_OFF_WILL_MAKE_THE_SAYSO_BUTTON_DISAPPEAR_ON_ALL_PAGES"
              | translate
          }}
        </h5>
      </div>
      <!-- sayso analytics -->
      <div class="onsip-sayso-settings-grid">
        <span class="onsip-sayso-settings-toggles">
          <div>{{ "ONSIP_I18N.ENABLE_SAYSO_ANALYTICS" | translate }}</div>
          <mat-slide-toggle
            color="primary"
            (change)="enableSaysoPricingAnalytics($event)"
            [(ngModel)]="saysoPricingAnalyticsToggle"
          >
          </mat-slide-toggle>
        </span>
        <h5>
          {{
            "ONSIP_I18N.TOGGLING_THIS_ON_WILL_ALLOW_YOU_TO_MONITOR_AGENT_PERFORMANCE_VIEW_CALL_METRICS_AND_TRACK_VISITOR_ENGAGEMENT"
              | translate
          }}
        </h5>
        @if (!saysoPricingEnabled) {
        <h5 (click)="openSaysoPricingDialog()" class="sayso-upgrade-link primary-500">
          {{ "ONSIP_I18N.UPGRADE_TO_ACCESS_THIS_FEATURE" | translate }}
        </h5>
        }
      </div>
      <!-- sayso screenshare -->
      <div class="onsip-sayso-settings-grid">
        <span class="onsip-sayso-settings-toggles">
          <div>{{ "ONSIP_I18N.ENABLE_SAYSO_SCREENSHARE" | translate }}</div>
          <mat-slide-toggle
            color="primary"
            (change)="enableSaysoScreenShare($event)"
            [(ngModel)]="saysoPricingScreenshareToggle"
          >
          </mat-slide-toggle>
        </span>
        <h5>
          {{
            "ONSIP_I18N.TOGGLING_THIS_ON_WILL_ALLOW_YOUR_TOPIC_REPRESENTATIVES_TO_SHARE_THEIR_SCREEN_WHILE_ON_VIDEO_CALLS"
              | translate
          }}
        </h5>
        @if (!saysoPricingEnabled) {
        <h5 (click)="openSaysoPricingDialog()" class="sayso-upgrade-link primary-500">
          {{ "ONSIP_I18N.UPGRADE_TO_ACCESS_THIS_FEATURE" | translate }}
        </h5>
        }
      </div>
      <!-- sayso remove onsip branding -->
      <div class="onsip-sayso-settings-grid">
        <span class="onsip-sayso-settings-toggles">
          <div>{{ "ONSIP_I18N.REMOVE_ONSIP_BRANDING" | translate }}</div>
          <mat-slide-toggle
            color="primary"
            (change)="enableSaysoBranding($event)"
            [(ngModel)]="saysoPricingBrandingToggle"
          >
          </mat-slide-toggle>
        </span>
        <h5>
          {{
            "ONSIP_I18N.TOGGLING_THIS_ON_WILL_ALLOW_YOU_TO_REMOVE_OUR_LOGO_ON_THE_SAYSO_WIDGET"
              | translate
          }}
        </h5>
        @if (!saysoPricingEnabled) {
        <h5 (click)="openSaysoPricingDialog()" class="sayso-upgrade-link primary-500">
          {{ "ONSIP_I18N.UPGRADE_TO_ACCESS_THIS_FEATURE" | translate }}
        </h5>
        }
      </div>
      <div>
        <div class="mat-button-2">{{ "ONSIP_I18N.CHECK_CONNECTION" | translate }}</div>
        <h5>
          {{ "ONSIP_I18N.CHECK_TO_SEE_IF_SAYSO_IS_CORRECTLY_INSTALLED_ON_YOUR_SITE" | translate }}
        </h5>
        <onsip-test-installation></onsip-test-installation>
      </div>
      <div class="sayso-settings-link">
        <a
          id="onsip--sayso-installation--view-guide"
          class="primary-500"
          [routerLink]="views.SAYSO_INSTALLATION"
        >
          {{ "ONSIP_I18N.VIEW_INSTALLATION_GUIDE" | translate }}
        </a>
        <a
          id="onsip--sayso-support--call-support"
          class="primary-500"
          [matTooltip]="'ONSIP_I18N.CALL_SUPPORT' | translate"
          matTooltipPosition="right"
          matTooltipClass="onsip-tooltip-background"
          [routerLink]="views.CONTACT_SUPPORT"
        >
          {{ "ONSIP_I18N.NEED_HELP" | translate }}
        </a>
      </div>
    </mat-card-content>
  </mat-card>
</onsip-fixed-width-card-list>
@if (showPreview | async) {
<div class="sticky-container">
  @if (allTopicsDisabled | async) {
  <div class="preview-container">
    <onsip-animation class="empty-preview" filename="loadingballs"></onsip-animation>
    <div class="empty-state-text">
      <h3>{{ "ONSIP_I18N.SAYSO_DISABLED" | translate }}</h3>
      <div>
        {{ "ONSIP_I18N.THIS_BUTTON_WILL_NOT_APPEAR_TO_VISITORS_UNTIL_YOU_REENABLE" | translate }}
      </div>
    </div>
  </div>
  } @else {
  <onsip-app-topics-list-preview class="preview-container"> </onsip-app-topics-list-preview>
  }
  <div class="onsip-blob-container">
    <img class="blob" [src]="'resources/img/preview-background-blob.svg'" alt="Background Blob" />
  </div>
</div>
}
